module.exports = __webpack_public_path__ + "img/brushes-tablet_cn.23a2c77.jpg";